import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import Img from 'gatsby-image';

import Layout from '../../components/layout/layout';
import Service from '../../components/service/service';

import './service.template.scss';

export default ({
  location,
  data: {
    service,
    services,
    site: {
      siteMetadata: { title: siteTitle },
    },
  },
}) => (
  <Layout location={location}>
    <Helmet title={`${siteTitle} - ${service.name}`}>
      <meta name="description" content="Spazio 536 - Centro estetico" />
    </Helmet>
    <Img
      fluid={service.image.fluid}
      style={{ maxHeight: '475px', borderBottom: '13px solid #C48F2C' }}
    />
    <div className="page-title-wrapper" style={{ marginBottom: 'auto' }}>
      <h4 className="page__title">{service.name}</h4>
      <hr />
      <span className="page__subtitle" style={{ marginBottom: 'auto' }}>
        I nostri servizi
      </span>
    </div>

    <span className="service__description">{service.description?.description}</span>

    <div className="services">
      {services.edges.map(service => (
        <Service service={service.node} />
      ))}
    </div>
  </Layout>
);

export const pageQuery = graphql`
  query ServiceBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }

    service: contentfulService(slug: { eq: $slug }) {
      name
      description {
        description
      }
      image {
        fluid {
          ...GatsbyContentfulFluid_tracedSVG
        }
      }
    }

    services: allContentfulService(filter: { slug: { ne: $slug } }) {
      edges {
        node {
          slug
          name
          image {
            fluid {
              ...GatsbyContentfulFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`;
